'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: 0;\n  height: 0;\n  position: fixed;\n  pointer-events: none;\n  visibility: hidden;\n  opacity: 0;\n'], ['\n  width: 0;\n  height: 0;\n  position: fixed;\n  pointer-events: none;\n  visibility: hidden;\n  opacity: 0;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Audio = _styledComponents2.default.audio(_templateObject);

var SoundPlayer = function (_Component) {
  _inherits(SoundPlayer, _Component);

  function SoundPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SoundPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundPlayer.__proto__ || Object.getPrototypeOf(SoundPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.audio = null, _this.fadeDuration = 50, _this.fade = function () {
      var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var _this$props = _this.props,
          fade = _this$props.fade,
          fadeLength = _this$props.fadeLength;
      var _this2 = _this,
          audio = _this2.audio,
          mounted = _this2.mounted,
          fadeDuration = _this2.fadeDuration;
      var volume = (fadeLength - interval * fadeDuration) / fadeLength;
      if (!audio || volume < 0 || !fade || !mounted) return;
      audio.volume = volume;
      setTimeout(function () {
        return _this.fade(interval + 1);
      }, _this.fadeDuration);
    }, _this.ref = function (dom) {
      _this.audio = dom;
      if (_this.props.reference) _this.props.reference(dom);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SoundPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      if (this.props.fade) this.fade();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.fade && !prevProps.fade) this.fade();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          src = _props.src,
          fade = _props.fade,
          fadeLength = _props.fadeLength,
          props = _objectWithoutProperties(_props, ['src', 'fade', 'fadeLength']);

      return _react2.default.createElement(Audio, _extends({}, props, {
        innerRef: this.ref
      }), _react2.default.createElement('source', {
        src: src,
        type: 'audio/mpeg'
      }));
    }
  }]);

  return SoundPlayer;
}(_react.Component);

SoundPlayer.propTypes = {
  src: _propTypes2.default.string,
  fade: _propTypes2.default.bool,
  fadeLength: _propTypes2.default.number,
  reference: _propTypes2.default.func
};
SoundPlayer.defaultProps = {
  fade: false,
  fadeLength: 1000
};
exports.default = SoundPlayer;